import React from "react";
import { withTranslation } from "react-i18next";
import Button from "@material-ui/core/Button";
import UserInput from "../../components/UserInput/UserInput";
import axios from "../../utils/Axios/axiosProxy";
import { validateInput } from "../../utils/Functions/functions";
import styles from "./UserEntry.module.scss";
import userInputStyle from "../../components/UserInput/UserInput.module.scss";
import i18n from "../../utils/LanguageSelector/i18n";
class UserRegister extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      companyname: "",
      taxnr: "",
      passwordError: "",
      emailError: "",
      accountCreated: false,
    };
  }
  createAccount = () => {
    let data = { email: this.state.email, password: this.state.password };
    axios
      .post("/api/user/register", JSON.stringify(data), {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("AXIOS RESPONSE: ", response.statusText);
      })
      .catch((error) => {
        console.log("AXIOS ERROR: ", error.response.data);
        this.setState({
          emailError:
            error.response.data === "email already taken"
              ? "We already have an account with this e-mail address"
              : "",
        });
      })
      .catch((error) => console.log("submitToDB error", error));
  };
  handleChange = (event) => {
    if (event.target.id === "password") {
      this.setState({
        passwordError: validateInput("password", event.target.value).password,
      });
    }
    if (event.target.id === "email") {
      this.setState({
        emailError: validateInput("email", event.target.value).email,
      });
      console.log(validateInput("email", event.target.value));
    }
    this.setState({ [event.target.id]: event.target.value });
  };
  render() {
    const RegisterInputs = [
      { label: i18n.t("general.email"), id: "email", type: "text" },
      { label: i18n.t("general.companyname"), id: "companyname", type: "text" },
      { label: i18n.t("general.taxnr"), id: "taxnr", type: "text" },
      { label: i18n.t("general.password"), id: "password", type: "password" },
    ];
    return (
      <div className={styles.UserEntryContainer}>
        <div className={styles.UserEntryContent}>
          <div>
            <h2 className={styles.UserEntryTitle}>
              {i18n.t("register.createacc")}
            </h2>
          </div>
          {this.state.accountCreated ? (
            <div className={`${styles.RegisterInputs} FlexCenter Column`}>
              <p className={styles.AccountCreatedText}>
                {i18n.t("register.thanks")}
              </p>
              <p className={styles.AccountCreatedText}>
                {i18n.t("register.activationnoti")}
              </p>
            </div>
          ) : (
            <div className={`${styles.UserEntryInputs} FlexCenter Column`}>
              {RegisterInputs.map((input) => {
                return (
                  <>
                    <UserInput
                      key={input.id}
                      name={input.label}
                      id={input.id}
                      type={input.type === "password" ? input.type : null}
                      className={userInputStyle.RegInput}
                      value={this.state[input.id]}
                      onChange={(event) => {
                        this.handleChange(event);
                      }}
                    />
                    {input.id === "email" ? (
                      <div className={styles.UserEntryErrorMessageContainer}>
                        <span className={styles.UserEntryErrorMessage}>
                          {this.state.emailError}
                        </span>
                      </div>
                    ) : null}
                  </>
                );
              })}
              <div className={styles.UserEntryErrorMessageContainer}>
                <span className={styles.UserEntryErrorMessage}>
                  {this.state.passwordError}
                </span>
              </div>
              <div className={styles.UserEntryButton}>
                <Button
                  onClick={() => {
                    if (
                      this.state.passwordError.length === 0 &&
                      this.state.emailError.length === 0 &&
                      this.state.password.length > 0 &&
                      this.state.email.length > 0
                    ) {
                      this.createAccount();
                    }
                  }}
                  className={`ToreaBay Medium MarginHorizontal`}
                >
                  {i18n.t("register.createaccbtn")}
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withTranslation()(UserRegister);
